<div *ngIf="visible$ | async">
  <div class="modal">
    <div class="modal-body">
      <button class="close-button" aria-label="Close alert" type="button" data-close (click)="hide()">
        <span aria-hidden="true">&times;</span>
      </button>
      <ng-content></ng-content>
    </div>
  </div>
  <div class="modal-background"></div>
</div>
